interface Props {
  onStart: () => void;
}

export default function TestIntro({ onStart }: Props) {
  return (
    <div className="max-w-2xl mx-auto">
      {/* Hero Card */}
      <div className="bg-primary-500 rounded-2xl p-8 md:p-10 text-white text-center mb-6">
        <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl mx-auto mb-5">
          <i className="ri-compass-3-line text-3xl text-white"></i>
        </div>
        <h1 className="font-heading text-2xl md:text-3xl font-bold mb-3">
          계열·진로·전공·직업 탐색 검사
        </h1>
        <p className="text-primary-100 text-sm md:text-base leading-relaxed">
          나의 흥미와 가치관을 바탕으로 맞는 계열과 진로를 찾고,
          <br className="hidden md:block" />
          추천 전공학과와 관련 직업까지 연결해 드립니다.
        </p>
      </div>

      {/* Info Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {[
          { icon: 'ri-time-line', title: '소요 시간', value: '약 20~25분' },
          { icon: 'ri-question-answer-line', title: '문항 수', value: '총 162문항' },
          { icon: 'ri-bar-chart-2-line', title: '분석 내용', value: '흥미·가치관' },
        ].map((item) => (
          <div key={item.title} className="bg-background-50 border border-background-200 rounded-xl p-4 text-center">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-100 rounded-lg mx-auto mb-2">
              <i className={`${item.icon} text-primary-600`}></i>
            </div>
            <div className="font-bold text-foreground-950">{item.value}</div>
            <div className="text-xs text-foreground-500 mt-0.5">{item.title}</div>
          </div>
        ))}
      </div>

      {/* What you'll get */}
      <div className="bg-background-50 border border-background-200 rounded-xl p-6 mb-6">
        <h3 className="font-semibold text-foreground-950 mb-4 flex items-center gap-2">
          <i className="ri-gift-line text-accent-500"></i>
          검사 후 받을 수 있는 것
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[
            { icon: 'ri-road-map-line', text: '나에게 맞는 추천 계열 (인문/사회/자연/공학/예체능 등)' },
            { icon: 'ri-building-4-line', text: '추천 대학 전공학과 목록' },
            { icon: 'ri-briefcase-3-line', text: '관련 직업 리스트' },
            { icon: 'ri-book-open-line', text: '계열별 권장 고교 선택과목' },
            { icon: 'ri-shield-check-line', text: '응답 일관성 분석 (정직하게 답했는지 확인)' },
            { icon: 'ri-palette-line', text: '나에게 맞는 추천 취미·특기' },
          ].map((item) => (
            <div key={item.text} className="flex items-start gap-2">
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-primary-500 text-sm`}></i>
              </div>
              <span className="text-foreground-600 text-sm">{item.text}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Notice */}
      <div className="bg-accent-50 border border-accent-200 rounded-xl p-4 mb-6">
        <div className="flex gap-2">
          <i className="ri-information-line text-accent-500 flex-shrink-0 mt-0.5"></i>
          <p className="text-accent-700 text-sm">
            이 검사는 <strong>Holland 직업 흥미 유형</strong>과 <strong>직업 가치관</strong>을 기반으로 합니다.
            각 문항을 <strong>0~10점</strong>으로 정밀하게 평가해주세요. 같은 내용을 다르게 물어보는 문항이 포함되어 있어,
            <strong>솔직하고 정직하게</strong> 일관되게 답할수록 더 정확한 결과가 나와요. 응답이 일관적이지 않으면
            다시 검사할 것을 권장해요. 결과는 참고용이며 전문 상담을 대체하지 않습니다.
          </p>
        </div>
      </div>

      <button
        onClick={onStart}
        className="whitespace-nowrap w-full bg-primary-500 hover:bg-primary-600 text-white font-bold py-4 rounded-xl text-base transition-colors cursor-pointer"
      >
        검사 시작하기 <i className="ri-arrow-right-line ml-2"></i>
      </button>
    </div>
  );
}